import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { newPassword } from "../apiCalls/user";
import { toast } from "react-toastify";

const NewPassword = () => {
  const { token } = useParams();
  console.log(token);
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const { isFetching, error } = useSelector((state) => state.user);

  const handleClick = async (e) => {
    console.log("send mail");
    e.preventDefault();
    const res = await newPassword(
      {
        password,
        token,
      },
      errorMsgNoti
    );
    if (res?.data?.success === true) {
      toast.success(`🦄 ${res.data.message}`);
    }
  };

  const errorMsgNoti = (res) => {
    toast.error(`🦄 ${res}`);
  };

  console.log("Error", error);

  return (
    <section className="login-section">
      <div className="form-wrapper">
        <h2>SET NEW PASSWORD</h2>
        <div className="form">
          <div className="form-input">
            <input
              type="password"
              placeholder="New Password"
              name="password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            className="btn mb-4 mt-1 w-100 br-2"
            onClick={handleClick}
            disabled={isFetching}
          >
            Submit
          </button>
        </div>
      </div>
    </section>
  );
};

export default NewPassword;
